// extracted by mini-css-extract-plugin
export default {"wrapper":"JSS8g","contentWrapper":"ah6Ks","cardWrapper":"Xce4I","ctaTemplateCardContainer":"qy6TL"};